export default {
      id: "linkedin-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }